import React, { FC } from "react";
import {
  Autocomplete,
  Box,
  Dialog,
  DialogContent,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import {
  confirmButton,
  dropDownOptions,
  dropDownStyle,
  editDialog,
  editDialogContent,
  textStyle,
  titleStyle,
} from "./editProduct.styles";
import QuantityField from "../../common/QuantityField";
import { ProductListingProps } from "../../types/ProductList";
import { Order } from "../../dto/orderSummaryTypes";
import { ActionButton } from "../../common/actionButton/ActionButton";
import { Close } from "@mui/icons-material";

type EditProductProps = {
  show: boolean;
  setShow: (show: boolean) => void;
  selectedItem: Order | undefined;
  setSelectedItem: (item: Order) => void;
  products: ProductListingProps[];
  onConfirm: () => void;
  mode?: "edit" | "add";
};

const EditProductModal: FC<EditProductProps> = ({
  show,
  setShow,
  selectedItem,
  setSelectedItem,
  products,
  onConfirm,
  mode = "edit",
}) => {
  const mappedProds: Order[] = products.map(({ id, name, images }) => ({
    id: id,
    name: name,
    quantity: 20,
    liters: 1,
    image: images,
    productId: id,
  }));

  return (
    <Dialog
      open={show}
      onClose={() => setShow(false)}
      PaperProps={{
        style: editDialog,
      }}
      disableScrollLock
    >
      <DialogContent sx={editDialogContent}>
        <Box display={"flex"} justifyContent={"space-between"}>
          <Typography sx={titleStyle}>
            {mode === "add" ? "Add Product" : "Edit Product"}
          </Typography>
          <IconButton onClick={() => setShow(false)}>
            <Close color="primary" />
          </IconButton>
        </Box>
        <Typography sx={textStyle}>Select Product</Typography>
        <Autocomplete
          value={selectedItem}
          onChange={(_, newValue) => {
            if (newValue) {
              const updatedItem = {
                ...newValue,
                id: selectedItem?.id || newValue.id,
              };
              setSelectedItem(updatedItem);
            }
          }}
          getOptionLabel={(option) => option?.name || ""}
          renderInput={(params) => <TextField {...params} sx={{ p: 0 }} />}
          options={mappedProds}
          noOptionsText={"No products found."}
          disableClearable
          sx={dropDownStyle}
        />

        <Typography sx={textStyle}>Select type of keg</Typography>

        <Select
          value={selectedItem?.quantity || 20}
          onChange={(value) =>
            selectedItem &&
            setSelectedItem({
              ...selectedItem,
              quantity: +value.target.value,
            })
          }
          fullWidth
          sx={dropDownStyle}
          MenuProps={{
            PaperProps: {
              style: dropDownOptions,
            },
          }}
        >
          {[20, 30, 50].map((size) => (
            <MenuItem value={size} key={`Keg_${size}L`}>
              {size}L
            </MenuItem>
          ))}
        </Select>

        <Typography sx={textStyle}>Select quantity</Typography>
        <QuantityField
          qty={selectedItem?.liters ?? 1}
          setQty={(value) =>
            selectedItem && setSelectedItem({ ...selectedItem, liters: value })
          }
        />
        <Box flexDirection={"column"} display={"flex"}>
          <ActionButton
            label="Confirm"
            isSellerPortal
            onClick={onConfirm}
            sx={confirmButton}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default EditProductModal;
